interface SelectOptions extends Record<number | string, string> {
  other: string;
}

export const plural = (value: number, options: SelectOptions): string => {
  const strValue = String(value);
  for (const key of Object.keys(options)) {
    if (strValue === key) {
      return options[key];
    }
  }
  return options.other ?? '';
};

export const select = (value: unknown, options: SelectOptions): string => {
  const keys = Object.keys(options);
  for (const key of keys) {
    if (value === key) {
      return options[key];
    }
  }
  return options.other ?? '';
};
